import CookieConsent from "react-cookie-consent"
import { getBrockwaysColourHex, getFncsColourHex, getKellarsColourHex, getValleyColourHex } from "../../lib/methods/getOrderStatusVariant"
import { config as AppConfig} from '../../lib/config'
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store"; 
import { Link } from "react-router-dom";
import { store } from '../../index';

const configThemeName: string = process.env.NODE_ENV === 'development' ? AppConfig.dev.theme : AppConfig.build.theme;

const CookieBanner = () => {
    //used to style cookie banner for different sites
  const setupTheme = useSelector((state: ApplicationState) => state.clientSetup.params?.ThemeOverride);
  // const repLogonLockScreenTimeoutMilSecs = useSelector((state: ApplicationState) => state.clientSetup.params?.RepLogonLockScreenTimeoutMilSecs);
  const repLogonLockScreenTimeoutMilSecs = store.getState().clientSetup.params?.RepLogonLockScreenTimeoutMilSecs;
  const themeCode: string = setupTheme && setupTheme !== '' ? setupTheme : configThemeName;


    return (
      <CookieConsent
      location='bottom'
      //debug={true}
      cookieName='Realitex200EcommCookieAccept'
      style={{background: themeCode === 'sj5xkM6L' ? getBrockwaysColourHex("green") : themeCode === 'fNc54H2J' ? getFncsColourHex('lighterGrey') : themeCode === 'qQkCE4Xe' ? getKellarsColourHex('almostBlack') : themeCode === 'vall41JU' ? getValleyColourHex('clarnet') : '#3a3b3e', textAlign: 'center', color: themeCode === 'fNc54H2J' ? 'black' : 'white'}}

      expires={365}
      buttonStyle={{backgroundColor:  themeCode === "sj5xkM6L" ? getBrockwaysColourHex("black") : themeCode === 'fNc54H2J' ? getFncsColourHex('green')  : "#28A745", color:  themeCode === "sj5xkM6L" ? "white" : "white", borderRadius: '4px' }}
    >
      This site uses non-analytical cookies to enhance user experience and provide website functionality. For more information, please see our <Link to={'/privacy-policy'}>Privacy Policy</Link>.

    </CookieConsent>
    )
  };
  export default CookieBanner;
